// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORM_EXIT_ARE_YOU_SURE = "Obsah formul\u00e1ra bude zmazan\u00fd, si si ist\u00e1, \u017ee chce\u0161 pokra\u010dova\u0165?";
export const TOAST_ERRORS_IN_FORM = "Formul\u00e1r sa nepodarilo odosla\u0165. Niekde v \u0148om m\u00e1\u0161 chybu.";
